import type { OrganizationContextSelectProps } from "./organization-context-select.type";

import { Select } from "antd";
import { useTranslation } from "react-i18next";

import { useOrganizationContextSelect } from "./organization-context-select.hook";

export const OrganizationContextSelect = ({
  size,
  variant,
  styles,
}: OrganizationContextSelectProps) => {
  const { t } = useTranslation();
  const { value, options, onContextChange } = useOrganizationContextSelect();

  return (
    <Select
      value={value}
      options={options}
      onChange={onContextChange}
      size={size}
      variant={variant}
      styles={styles}
      listHeight={644} // show around 20 organizations
      popupMatchSelectWidth={false} // show full width options
      placeholder={t("context:select.placeholder")}
      classNames={{
        root: "organization-context-select",
        content: "organization-context-select-content",
        suffix: "organization-context-select-suffix",
      }}
    />
  );
};
